import { Component, Host, h } from '@stencil/core'
import paypal from './assets/paypal.svg'
import visa from './assets/visa.svg'
import mastercard from './assets/mastercard.svg'
import amex from './assets/amex.svg'
import ec from './assets/ec.svg'
import invoice from './assets/invoice.svg'

/**
 * Represents the payment information component.
 * Displays the payment methods available in the store.
 */
@Component({
    tag: 'wf-payment-methods',
    styleUrl: 'wf-payment-methods.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfPaymentMethods {

    /**
     * @inheritDoc
     */
    render() {
        return (
            <Host>
                <div class="title" part="title">Zahlungsmethoden</div>
                <div class="images">
                    <img src={paypal} alt="Paypal Logo"/>
                    <img src={visa} alt="Visa Logo"/>
                    <img src={mastercard} alt="Mastercard Logo"/>
                    <img src={amex} alt="Amex Logo"/>
                    <img src={ec} alt="EC Logo"/>
                    <img src={invoice} alt="Auf Rechnung"/>
                </div>
            </Host>
        )
    }
}
